import { loading } from "../types";

const INITIAL_STATE = {
    formButtonLoading: {},
    ticketTableLoading: false
}

const loadingreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case loading.FORM_BUTTON_LOADING:
            const {formName , isLoading} = action.payload
            return {
                ...state,
                formButtonLoading:{ 
                    ...state.formButtonLoading, [formName] : isLoading
                }
            }
        case loading.MODAL_BUTTON_LOADING:
            return {
                ...state,
                modalLoading: action.payload
            }    
        case loading.TICKETS_TABLE_LOADING:
            return {
                ...state,
                ticketTableLoading: action.payload
            }  
        case loading.VIEW_TICKET_LOADING:
            return {
                ...state,
                viweTicketLoading: action.payload
            }
        default :
            return state    
    }
}

export default loadingreducer